import {useMainStore} from "../state/store";

export default {
    beforeRouteLeave (to, from, next) {
        const mainStore = useMainStore();
        if (this.form.isDirty()) {
            mainStore.confirmLeaving(next);
        } else {
            next();
        }
    }
}
